import {clientPostWrapper} from "../api/Api";
import {INSERT_NEW_PROMO_CODE} from "../common/constants/routes";


export const createPromoCode = (promoCode) => {
    return clientPostWrapper(INSERT_NEW_PROMO_CODE, {promoCode})
}
